module.exports = __webpack_public_path__ + "img/dea-formazione-ico-tecnologia.ae62bd50.svg";